// extracted by mini-css-extract-plugin
export default {"root":"SimpleOptionCard_root__GY4lG","active":"SimpleOptionCard_active__DE7mb","clickable":"SimpleOptionCard_clickable__pIONp","icon":"SimpleOptionCard_icon__IF+-g"};